import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"

import {deleteFlashMessage} from "~/actions/flashMessages"
import {FlashMessage} from "~/components"

class FlashMessagesList extends Component {
  render() {
    const messages = this.props.messages.map(message => (
      <FlashMessage
        key={message.id}
        message={message}
        deleteFlashMessage={this.props.deleteFlashMessage}
      />
    ))

    return <div>{messages}</div>
  }
}

FlashMessagesList.propTypes = {
  messages: PropTypes.array.isRequired,
  deleteFlashMessage: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  messages: state.flash
})

export default connect(
  mapStateToProps,
  {deleteFlashMessage}
)(FlashMessagesList)



// WEBPACK FOOTER //
// ./src/components/flash/FlashMessagesList.js